import React from "react";

const ModalWrapper = ({ open, title, children, onClose, size = "modal-lg" }) => {
  if (!open) return null;
  return (
    <div
      className="modal fade show d-block management-modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ backgroundColor: "rgba(15, 23, 42, 0.45)" }}
    >
      <div className={`modal-dialog ${size} modal-dialog-centered`} role="document">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default function NivelesFormModal({
  modal,
  formNuevo,
  setFormNuevo,
  formEditar,
  setFormEditar,
  savingNuevo,
  savingEditar,
  deleting,
  nivelSeleccionado,
  cerrarModal,
  handleCrearNivel,
  handleActualizarNivel,
  handleEliminarNivel,
  canUpdate = true,
  canDelete = true,
}) {
  return (
    <>
      <ModalWrapper open={modal === "nuevo"} title="Registrar nuevo nivel" onClose={cerrarModal}>
        <form onSubmit={handleCrearNivel}>
          <div className="modal-body pt-0">
            <div className="mb-3">
              <label className="form-label fw-semibold">Nombre</label>
              <input
                type="text"
                className="form-control"
                placeholder="Ej. Nivel I"
                value={formNuevo.nombre}
                onChange={(e) => setFormNuevo((prev) => ({ ...prev, nombre: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Descripcion</label>
              <textarea
                className="form-control"
                rows={3}
                placeholder="Describe las caracteristicas del nivel"
                value={formNuevo.descripcion}
                onChange={(e) => setFormNuevo((prev) => ({ ...prev, descripcion: e.target.value }))}
              />
            </div>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="nivelNuevoActivo"
                checked={formNuevo.activo}
                onChange={(e) => setFormNuevo((prev) => ({ ...prev, activo: e.target.checked }))}
              />
              <label className="form-check-label" htmlFor="nivelNuevoActivo">
                {formNuevo.activo ? "Nivel activo" : "Nivel inactivo"}
              </label>
            </div>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={cerrarModal}
              disabled={savingNuevo}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary" disabled={savingNuevo}>
              {savingNuevo ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  Guardando...
                </>
              ) : (
                "Guardar nivel"
              )}
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        open={modal === "editar" && canUpdate}
        title={`Editar nivel${nivelSeleccionado ? `: ${nivelSeleccionado.nombre}` : ""}`}
        onClose={cerrarModal}
      >
        <form onSubmit={handleActualizarNivel}>
          <div className="modal-body pt-0">
            <div className="mb-3">
              <label className="form-label fw-semibold">Nombre</label>
              <input
                type="text"
                className="form-control"
                value={formEditar.nombre}
                onChange={(e) => setFormEditar((prev) => ({ ...prev, nombre: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Descripcion</label>
              <textarea
                className="form-control"
                rows={3}
                value={formEditar.descripcion}
                onChange={(e) => setFormEditar((prev) => ({ ...prev, descripcion: e.target.value }))}
              />
            </div>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="nivelEditarActivo"
                checked={formEditar.activo}
                onChange={(e) => setFormEditar((prev) => ({ ...prev, activo: e.target.checked }))}
              />
              <label className="form-check-label" htmlFor="nivelEditarActivo">
                {formEditar.activo ? "Nivel activo" : "Nivel inactivo"}
              </label>
            </div>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={cerrarModal}
              disabled={savingEditar}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary" disabled={savingEditar || !canUpdate}>
              {savingEditar ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  Guardando...
                </>
              ) : (
                "Guardar cambios"
              )}
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        open={modal === "eliminar" && canDelete}
        title="Eliminar nivel"
        onClose={cerrarModal}
        size="modal-md"
      >
        <div className="modal-body pt-0">
          <p className="mb-2">
            Estas a punto de eliminar el nivel{" "}
            <strong>{nivelSeleccionado?.nombre || "seleccionado"}</strong>.
          </p>
          <p className="text-muted mb-0">
            Esta accion desactivara el nivel y evitara que se utilice en nuevos registros.
          </p>
        </div>
        <div className="modal-footer border-0 pt-0">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={cerrarModal}
            disabled={deleting}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleEliminarNivel}
            disabled={deleting || !canDelete}
          >
            {deleting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Eliminando...
              </>
            ) : (
              "Eliminar"
            )}
          </button>
        </div>
      </ModalWrapper>
    </>
  );
}
